<script>
import {maxLength, minLength, required, requiredIf} from "vuelidate/lib/validators";
import axios from "axios";
import Multiselect from "vue-multiselect";
import identificationCodePolicy from "@/views/tourism/mixins/identificationCodePolicy";

export default {
  name: "TouristsForm",
  components: {Multiselect},
  mixins: [identificationCodePolicy],
  model: {
    prop: 'TouristsList',
    event: 'input',
  },
  props: {
    TouristsList: Array,
    submitCheck: Boolean,
  },
  validations: {
    TouristsList: {
      $each: {
        name: {
          required, minLength: minLength(2), maxLength: maxLength(30),
          onlyLatinCharacters(value) {
            return this.onlyLatinCharactersAndNum(value);
          }
        },
        surname: {
          required: requiredIf(function (nestedModel) {
            return true
          }), minLength: minLength(2), maxLength: maxLength(30),
          onlyLatinCharacters(value) {
            return this.onlyLatinCharacters(value);
          }},
        dateBirth: {
          required,
          minLength: minLength(10),
          maxLength: maxLength(10),
          customMinLength(value) {
            return value !== null && value.length === 10;
          },
          daysInMonth: (value) => {
            if (value === null) {
              return true
            }

            return (parseInt(moment(value, 'DD.MM.YYYY').format('DD'))) <= moment(value, 'DD.MM.YYYY').daysInMonth();
          },
        },
        identificationCode: {
          // Для СК з правилом за віком (Guardian — від 16 років) ІПН
          // обов'язковий незалежно від галочки «Відсутній ІПН».
          required: requiredIf(function (nestedModel) {
            return this.isInnRequiredByAge(nestedModel.dateBirth) || !nestedModel.withoutIdentificationCode;
          }), customMinLength(value) {
            if (!this.required && (value === null || value === undefined || value === '')) {
              return true;
            }
            return value !== undefined && value !== null && value.length === 10;
          },
          unique(value) {
            const allCodes = this.TouristsList.map((tourist) => tourist.identificationCode);
            const count = allCodes.reduce((acc, code) => {
              if (code === '') {
                return acc;
              }
              acc[code] = (acc[code] || 0) + 1;
              return acc;
            }, {});

            const hasDuplicates = Object.values(count).some((val) => val > 1);
            return !hasDuplicates || false;
          },
          // Дата народження зашита в перших 5 цифрах ІПН — розбіжність
          // блокує перехід на наступний крок.
          matchesBirthDate(value, tourist) {
            if (tourist.withoutIdentificationCode && !this.isInnRequiredByAge(tourist.dateBirth)) {
              return true;
            }
            if (!value || value.length !== 10 || !tourist.dateBirth || tourist.dateBirth.length !== 10) {
              return true;
            }
            return this.validateTaxNumber(value, tourist.dateBirth);
          }
        },
        documentType: {},
        passportSerial: {required},
        passportNumber: {required},
        passportDate: {
          required,
          minDateValid(value, vm) {
            const passportDate = moment(value, 'DD.MM.YYYY')
            const birthDate = moment(vm.dateBirth, 'DD.MM.YYYY')

            return passportDate > birthDate
          }
        },
        passportEndDate: {},
        passportIssuedBy: {},
        withoutIdentificationCode: {},
        unzr: {},
        // city: {required},
        city: {},
        // street: {required},
        street: {},
        // house: {
        //   required, minLength: minLength(1), onlyLatinAndNumAndSpecials(value) {
        //     return this.onlyLatinAndNumAndSpecials(value);
        //   }
        // },
        house: {},
        // apartment: {
        //   minLength: minLength(1), onlyLatinAndNumAndSpecials(value) {
        //     return this.onlyLatinAndNumAndSpecials(value);
        //   }
        // },
        apartment: {}
      }
    },
  },
  data() {
    return {
      LetterMaskError: false,
      errors: {'tourist.errorBirthDate': []},
      payerIsTourist: false,
      searchInfo: null,
      citiesOptions: [ {"id": 1,"name": "Київ","name_full_name_ua": "м. Київ, Україна", "zone":1},
        {"id": 9,"name": "Дніпро","name_full_name_ua": "м. Дніпро, Дніпропетровська  обл., Україна", "zone":2},
        {"id": 11,"name": "Львів","name_full_name_ua": "м. Львів, Львівська  обл., Україна", "zone":1},
        {"id": 13,"name": "Одеса","name_full_name_ua": "м. Одеса, Одеська  обл., Україна", "zone":2},
        {"id": 14,"name": "Харків","name_full_name_ua": "м. Харків, Харківська  обл., Україна", "zone":2},
        {"id": 16,"name": "Запоріжжя","name_full_name_ua": "м. Запоріжжя, Запорізька  обл., Україна", "zone":3},
        {"id": 17,"name": "Кривий Ріг","name_full_name_ua": "м. Кривий Ріг, Дніпропетровська  обл., Україна", "zone":3},
        {"id": 21,"name": "Вінниця","name_full_name_ua": "м. Вінниця, Вінницька  обл., Україна", "zone":4},
        {"id": 36,"name": "Маріуполь","name_full_name_ua": "м. Маріуполь, Донецька  обл., Україна", "zone":4},
        {"id": 41,"name": "Полтава","name_full_name_ua": "м. Полтава, Полтавська  обл., Україна", "zone":4}],
    }
  },
  computed: {
    offerInfo() {
      return this.$store.getters.GET_TOURISM_INFO_OFFER;
    },
    allowedTouristDocuments() {
      return this.offerInfo?.available_documents ?? this.offerInfo?.allowed_documents ?? null;
    },
    allDocuments() {
      return this.$store.getters.DOCUMENTS_TYPES
    },
  },
  watch: {
    'TouristsList': {
      handler: async function (val, oldVal) {
        var $this = this;
        // Турист досяг віку, з якого ІПН обов'язковий, — галочка
        // «Відсутній ІПН» ховається, тож її значення скидається.
        val.forEach((tourist, idx) => {
          if (tourist.withoutIdentificationCode && this.isInnRequiredByAge(tourist.dateBirth)) {
            this.$set(this.TouristsList[idx], 'withoutIdentificationCode', false);
          }
        });
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.searchInfo.birthDates = [];
        this.TouristsList.forEach(item => {
          const birthDate = moment(item.dateBirth, 'DD.MM.YYYY');
          this.searchInfo.birthDates.push(moment(birthDate).format('DD.MM.YYYY'))
        });

        // $this.isLoadInsuredsListBySurname = true;
        this.timer = setTimeout(async () => {
          val.forEach((p, idx) => {
            // if(!this.insuredsListBySurname[idx]){
            //   this.insuredsListBySurname[idx] = [];
            // }
            // if(!this.insuredsList[idx]){
            //   this.insuredsList[idx] = [];
            // }
            $.each(p, async function (i,prop) {
              switch (i) {
                case 'name':
                  // $this.insuredsListBySurname[idx][i] = [];
                  return true;
                case 'dateBirth':
                  if (prop) {
                    if (moment().diff(moment(prop), 'days') < 0) {
                      $this.errors['tourist.errorBirthDate'][idx] = "Введіть коректно дату";
                      return true;
                    } else {
                      delete $this.errors['tourist.errorBirthDate'][idx];
                    }
                  }

                  return true;
                case 'identificationCode':
                  // Дата народження зафіксована з калькуляції, з ІПН її не
                  // перезаписуємо — розбіжність ловить правило matchesBirthDate
                  delete $this.errors['tourist[' + idx + '].identificationCode'];
                  return true;
                case 'documentType':
                  if (prop === 2) {//"DOCUMENT_EXTERNAL_PASSPORT"
                    $this.TouristsList[idx].passportEndDate = null;
                  }

                  return true;
                default:
                  return true;
              }
            })
          })
          // $this.isLoadInsuredsListBySurname = false;
          this.$store.commit('SET_TOURISM_INFO_TOURISTSLIST', this.TouristsList);
        }, 800);
      },
      deep: true
    },
  },
  methods: {
    onlyLatinAndNumAndSpecials(str) {
      if (str == null || str == "") return true;

      if (/^[a-zA-Z0-9а-яґєіїА-ЯЄҐЇІ\-.\/ ]+$/.test(str)) {
        // additional check for any number
        return /\d/.test(str);
      }
      return false;
    },
    LetterNumSymbolsMask(e){
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z0-9а-яґєіїА-ЯЄҐЇІ\-.\/ ]+$/.test(char)) {
        this.LetterMaskError = false;
        return true;
      } // Match with regex
      else {
        this.LetterMaskError = true;
        e.preventDefault();
      }
    },
    payerIsTouristFunc(event) {
      this.$emit('payerIsTourist', event)
    },
    disableTouristIdentificationCode(index) {
      if (this.isInnRequiredByAge(this.TouristsList[index].dateBirth)) {
        this.$set(this.TouristsList[index], 'withoutIdentificationCode', false);
        return;
      }
      this.$set(this.TouristsList[index], 'identificationCode', '');
      this.$set(this.TouristsList[index], 'withoutIdentificationCode', true);
    },
    onlyLatinCharactersAndNum(str) {
      if (str == undefined || str == null || str == "") return true;
      return /^[a-zA-Z0-9\- ]+$/.test(str);
    },
    getClientDataForUpdating() {
      this.$emit('input', this.TouristsList)
      this.$emit('updatedClientData')
    },
    LetterMask(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z\- ]+$/.test(char)) {
        this.LetterMaskError = false;
        return true;
      } // Match with regex
      else {
        this.LetterMaskError = true;
        e.preventDefault();
      }
    },
    getTouristMaskNumber(touristDocumentType) {
      switch (touristDocumentType) {
        case 3://"DOCUMENT_ID_CARD"
          return "#########";
        default:
          return "#######";
      }
    },
    isDocumentIdPassport(document) {
      return document === 3;
    },
    isDocumentExternalPassport(document) {
      return document === 2;
    },
    getTouristMaskSerial(touristDocumentType) {
      switch (touristDocumentType) {
        case 3:// "DOCUMENT_ID_CARD"
          return "########-#####";
        case 2:// "DOCUMENT_EXTERNAL_PASSPORT"
          return "MM";
        default:
          return "XX";
      }
    },
    getTouristDocumentList() {
      return this.allowedTouristDocuments.map(docId => {
        const matchingItem = this.allDocuments.find(item => item.id === docId);
        return {
          id: matchingItem.id,
          name: matchingItem.name,
          uid: matchingItem.uid,
        };
      });
    },
    validateTaxNumber(tax_number, date) {
      let tax_numberDate = moment('01.01.1900', 'DD.MM.YYYY').add(tax_number.substr(0, 5) - 1, 'day');
      let birthDate = moment(date, 'DD.MM.YYYY');

      return tax_numberDate.isSame(birthDate, 'year')
        && tax_numberDate.isSame(birthDate, 'month')
        && tax_numberDate.isSame(birthDate, 'day');
    },
    onlyLatinCharacters(str) {
      if (str == null || str == "") return true;
      return /^[a-zA-Z\- ]+$/.test(str);
    },
    hasError(name, index = false) {
      if (!index) {
        return this.errors[name] !== undefined;
      } else {
        if (!!this.errors[name]) {
          return this.errors[name][index] !== undefined;
        } else return false;
      }
    },
    searchCities(query) {
      if (query.length > 1) {
        this.fetchCities(query);
      }
    },
    fetchCities(query) {
      axios.get('/api/directories/cities/find?city=' + query).then(({data}) => {
        this.cities = data.data;
        this.citiesOptions = data.data;

        if (this.citiesOptions.length === 0) {
          this.citiesOptions.push(this.otherCity);
        }
      }).catch(err => (console.log(err)));
    },
  },
  created() {
    this.searchInfo = this.$store.getters.GET_SEARH_TOURISM_PARAMS;
  }
}
</script>

<template>
  <div class="col-12">
    <div class="row">
      <div v-for="(tourist, index) in $v.TouristsList.$each.$iter"
           :key="`tourist-${parseInt(index)+1}`"
           :id="`tourist-${parseInt(index)+1}`"
           class="col-lg-12 row passport-row">
        <div class="col-lg-12">
          <h3 class="mt">
            <span>Застраховані особи (учасники) {{ parseInt(index) + 1 }}</span>
          </h3>
        </div>
        <div class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group">
              <label :for="`tourist-${index}-name`">Ім’я *</label>
              <input v-model="tourist.name.$model"
                     :id="`tourist-${index}-name`"
                     @change="getClientDataForUpdating()" type="text"
                     placeholder="Ім’я (Тільки латинськи літери)"
                     v-on:keypress="LetterMask($event)"
                     :class="['form-control', {invalid: ((!$v.TouristsList.$each[index].name.required && submitCheck) ||  (!onlyLatinCharacters(tourist.name.$model)  && submitCheck))}]"
              >
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].name.required && submitCheck">Вкажіть
                ім’я </small>
              <small class="error"
                     v-if="LetterMaskError || !onlyLatinCharacters(tourist.name.$model)">Тільки
                латинські літери</small>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group surname-block">
              <label :for="`tourist-${index}-surname`">Прізвище *</label>
              <input v-model.trim="tourist.surname.$model"
                     :id="`tourist-${index}-surname`"
                     @change="getClientDataForUpdating()"
                     maxlength="30"
                     type="text"
                     v-on:keypress="LetterMask($event)"
                     placeholder="Прізвище (Тільки латинськи літери)"
                     :class="['form-control surname-field',
                                                               {invalid: ((!$v.TouristsList.$each[index].surname.required && submitCheck) || (!$v.TouristsList.$each[index].surname.minLength) || (!$v.TouristsList.$each[index].surname.maxLength)) || (submitCheck && !onlyLatinCharacters(tourist.surname.$model))}]">
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].surname.required && submitCheck">Вкажіть
                прізвище (Тільки латинськи літери)</small>
              <small class="error"
                     v-if="LetterMaskError || !onlyLatinCharacters(tourist.surname.$model)">Тільки
                латинські літери</small>
              <small class="error"
                     v-else-if="!$v.TouristsList.$each[index].surname.minLength || !$v.TouristsList.$each[index].surname.maxLength">
                Введіть коректно прізвище</small>
            </div>
          </div>
        </div>
        <div class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group">
              <label :for="`tourist-${index}-date-birth`">Дата народження *</label>
              <!-- Дата зафіксована з калькуляції: офер розрахований на ці віки,
                   тому склад і дати народження туристів тут не змінюються -->
              <input v-mask="'##.##.####'" placeholder="Дата народження"
                     :id="`tourist-${index}-date-birth`"
                     disabled
                     v-model.trim="tourist.dateBirth.$model"
                     :class="['form-control', 'form-input_date', {invalid: ((!$v.TouristsList.$each[index].dateBirth.required && submitCheck) ||
                                                                 (!$v.TouristsList.$each[index].dateBirth.customMinLength && submitCheck) ||
                                                                  (hasError('tourist.errorBirthDate', index)) ||
                                                                  (!$v.TouristsList.$each[index].identificationCode.matchesBirthDate))}]">
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].dateBirth.required && submitCheck">Введіть
                дату народження</small>
              <small class="error"
                     v-else-if="(
                                                                           (!$v.TouristsList.$each[index].dateBirth.customMinLength ||
                                                                       !$v.TouristsList.$each[index].dateBirth.daysInMonth) && submitCheck)">
                Введіть коректну дату народження</small>
              <small class="invalid-feedback error"
                     v-else-if="hasError('personal.dateBirth')"
                     v-html="getError('personal.dateBirth')"></small>
              <small class="error" v-else-if="!$v.TouristsList.$each[index].identificationCode.matchesBirthDate">
                ІПН та Дата народження не співпадають
              </small>
              <small v-else class="text-muted">Вказана на калькуляції. Щоб змінити — поверніться до розрахунку</small>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group tooltip-group inn-block">
              <label :for="`tourist-${index}-uin`">ІПН *</label>
              <input type="text" placeholder="ІПН"
                     :id="`tourist-${index}-uin`"
                     v-model.trim="tourist.identificationCode.$model"
                     @change="getClientDataForUpdating()"
                     :disabled="tourist.withoutIdentificationCode.$model == true && !isInnRequiredByAge(tourist.dateBirth.$model)"
                     :class="['form-control inn-field', {invalid: !$v.TouristsList.$each[index].identificationCode.matchesBirthDate || (!$v.TouristsList.$each[index].identificationCode.required && submitCheck) || (!$v.TouristsList.$each[index].identificationCode.customMinLength && submitCheck) || (!$v.TouristsList.$each[index].identificationCode.unique)}]"
                     v-mask="'##########'" maxlength="10">
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].identificationCode.required && submitCheck">Введіть
                ІПН</small>
              <small class="error"
                     v-else-if="(!$v.TouristsList.$each[index].identificationCode.customMinLength && submitCheck)">
                Введіть коректно ІПН
              </small>
              <small class="error"
                     v-else-if="!$v.TouristsList.$each[index].identificationCode.matchesBirthDate">
                ІПН та Дата народження не співпадають
              </small>
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].identificationCode.unique">
                ІПН вже є в списку.
              </small>
              <small v-if="!isInnRequiredByAge(tourist.dateBirth.$model)">
                <div class="form-check">
                  <input
                    v-model.trim="tourist.withoutIdentificationCode.$model"
                    type="checkbox"
                    @click="disableTouristIdentificationCode(index)"
                    class="form-check-input"
                    :id="'withoutIdentificationCode-' + index">
                  <label class="form-check-label"
                         :for="'withoutIdentificationCode-' + index">Відсутній
                    ІПН</label>
                </div>
              </small>
              <small v-else class="text-muted d-block">
                ІПН обов'язковий для осіб від {{ tourismInnRequiredFromAge }} років
              </small>
            </div>
          </div>
        </div>
        <div class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group">
              <label :for="`tourist-${index}-document-type`">Тип документа *</label>
              <select name="documentsList"
                      :id="`tourist-${index}-document-type`"
                      class="custom-select documents-select mb-3"
                      @change="getClientDataForUpdating()"
                      v-model="tourist.documentType.$model">
                <option :value="documentItem.uid"
                        v-for="documentItem in getTouristDocumentList()">
                  {{ documentItem.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group tooltip-group inn-block">
              <label :for="`tourist-${index}-document-type`">УНЗР</label>
              <input type="text" placeholder="УНЗР"
                     :id="`tourist-${index}-unzr`"
                     v-model.trim="tourist.unzr.$model"
                     @change="getClientDataForUpdating()"
                     :class="['form-control inn-field', {invalid: false}]"
              >
            </div>
          </div>
        </div>
        <div class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group">
              <label :for="`tourist-${index}-passport-serial`">Серія закордонного паспорту *</label>
              <input v-model.trim="tourist.passportSerial.$model"
                     :id="`tourist-${index}-passport-serial`"
                     @change="getClientDataForUpdating()"
                     v-mask="getTouristMaskSerial(tourist.documentType.$model)"
                     type="text" placeholder="Серія закордонного паспорту"
                     :class="['form-control', {invalid: ((!$v.TouristsList.$each[index].passportSerial.required && submitCheck) || (submitCheck && !onlyLatinCharacters(tourist.passportSerial.$model)))}]">
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].passportSerial.required && submitCheck">Вкажіть
                серію та номер закордонного паспорту</small>
              <small class="error"
                     v-if="isDocumentExternalPassport(tourist.documentType.$model) && (LetterMaskError || !onlyLatinCharacters(tourist.passportSerial.$model))">Тільки
                латинські літери</small>
              <small class="error"
                     v-if="isDocumentIdPassport(tourist.documentType.$model) && !onlyLatinAndNumAndSpecials(tourist.passportSerial.$model)">Тільки
                цифри</small>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label :for="`tourist-${index}-passport-number`">Номер закордонного паспорту *</label>
              <input v-model.trim="tourist.passportNumber.$model"
                     :id="`tourist-${index}-passport-number`"
                     @change="getClientDataForUpdating()"
                     v-mask="getTouristMaskNumber(tourist.documentType.$model)"
                     type="text" placeholder="Номер закордонного паспорту"
                     :class="['form-control', {invalid: (!$v.TouristsList.$each[index].passportNumber.required && submitCheck)}]">
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].passportNumber.required && submitCheck">Вкажіть
                серію та номер закордонного паспорту</small>
            </div>
          </div>
        </div>
        <div class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group">
              <label :for="`tourist-${index}-passport-date`">Дата видачі закордонного паспорту *</label>
              <input v-model.trim="tourist.passportDate.$model"
                     :id="`tourist-${index}-passport-date`"
                     @change="getClientDataForUpdating()"
                     v-mask="'##.##.####'" type="text"
                     placeholder="Дата видачі закордонного паспорту"
                     :class="['form-control', {invalid: ((!$v.TouristsList.$each[index].passportDate.required || !$v.TouristsList.$each[index].passportDate.minDateValid) && submitCheck)}]">
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].passportDate.required && submitCheck">Вкажіть
                дату видачі</small>
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].passportDate.minDateValid && submitCheck">Дата видачі не може бути раніше за дату народження</small>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group">
              <label :for="`tourist-${index}-passport-issued-by`">Ким виданий документ *</label>
              <input v-model.trim="tourist.passportIssuedBy.$model"
                     :id="`tourist-${index}-passport-issued-by`"
                     @change="getClientDataForUpdating()" maxlength="200"
                     type="text" placeholder="Ким виданий документ"
                     :class="['form-control', {invalid: (!$v.TouristsList.$each[index].passportDate.required && submitCheck)}]">
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].passportDate.required && submitCheck">Вкажіть
                дату видачі</small>
            </div>
          </div>
          <div v-if="isDocumentIdPassport(tourist.documentType.$model)"
               class="col-lg-6">
            <div class="form-group">
              <label :for="`tourist-${index}-passport-end-date`">Дата закінчення дії *</label>
              <input v-model.trim="tourist.passportEndDate.$model"
                     :id="`tourist-${index}-passport-end-date`"
                     @change="getClientDataForUpdating()"
                     v-mask="'##.##.####'" type="text"
                     placeholder="Дата закінчення дії"
                     :class="['form-control', {invalid: (!$v.TouristsList.$each[index].passportDate.required && submitCheck)}]">
              <small class="error"
                     v-if="!$v.TouristsList.$each[index].passportDate.required && submitCheck">Вкажіть
                дату видачі</small>
            </div>
          </div>
        </div>
        <div class="col-12 row passport-row">
            <div class="col-lg-12 row passport-row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label :for="`tourist-${index}-city`">Місто реєстрації туриста</label>
<!--                  :class="['form-control', 'choice_city', {invalid: (!$v.TouristsList.$each[index].city.required && submitCheck)}]"-->
                  <multiselect
                    :id="`tourist-${index}-city`"
                    class="form-control"
                    v-model="tourist.city.$model"
                    :options="citiesOptions"
                    placeholder="Введіть назву міста"
                    @search-change="searchCities"
                    @change="getClientDataForUpdating()"
                    :internal-search="false"
                    :max-height="165"
                    :options-limit="300"
                    :allow-empty="false"
                    label="name_full_name_ua">
                  </multiselect>
<!--                  <small class="error"-->
<!--                         v-if="!$v.TouristsList.$each[index].city.required && submitCheck">Вкажіть-->
<!--                    місто прописки</small>-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label :for="`tourist-${index}-street`">Вулиця</label>
                  <input v-model="tourist.street.$model"
                         :id="`tourist-${index}-street`"
                         @change="getClientDataForUpdating()"
                         type="text"
                         placeholder="Вул."
                         class="form-control">
<!--                         :class="['form-control', {invalid: (!$v.TouristsList.$each[index].street.required && submitCheck) && submitCheck}]">-->
<!--                  <small class="error"-->
<!--                         v-if="!$v.TouristsList.$each[index].street.required && submitCheck">Вкажіть-->
<!--                    вулицю</small>-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label :for="`tourist-${index}-house`">Номер будинку</label>
                  <input v-model="tourist.house.$model"
                         :id="`tourist-${index}-house`"
                         @change="getClientDataForUpdating()"
                         v-on:keypress="LetterNumSymbolsMask($event)" type="text"
                         placeholder="Номер будинку"
                         class="form-control">
<!--                         :class="['form-control', {invalid: ((!$v.TouristsList.$each[index].house.required && submitCheck) || (!onlyLatinAndNumAndSpecials(tourist.house.$model)))&& submitCheck}]">-->
<!--                  <small class="error"-->
<!--                         v-if="!$v.TouristsList.$each[index].house.required && submitCheck">Вкажіть №-->
<!--                    будинку</small>-->
<!--                  <small class="error"-->
<!--                         v-if="LetterMaskError || (submitCheck && !onlyLatinAndNumAndSpecials(tourist.house.$model))">Тільки-->
<!--                    цифри, латинські літери, кирилиця та символи "-/"</small>-->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label :for="`tourist-${index}-apartment`">Квартира</label>
                  <input v-model="tourist.apartment.$model"
                         :id="`tourist-${index}-apartment`"
                         @change="getClientDataForUpdating()"
                         v-on:keypress="LetterNumSymbolsMask($event)" type="text"
                         placeholder="Квартира"
                         class="form-control">
<!--                         :class="['form-control', {invalid: ((!$v.TouristsList.$each[index].apartment.minLength) || (!onlyLatinAndNumAndSpecials(tourist.apartment.$model))) && submitCheck}]">-->
<!--                  <small class="error"-->
<!--                         v-if="!$v.TouristsList.$each[index].apartment.minLength && submitCheck">Вкажіть-->
<!--                    № квартири</small>-->
<!--                  <small class="error"-->
<!--                         v-if="(LetterMaskError || (!onlyLatinAndNumAndSpecials(tourist.apartment.$model))) && submitCheck">Тільки-->
<!--                    цифри, латинські літери, кирилиця та символи "-/"</small>-->
                </div>
              </div>
            </div>
        </div>

        <div v-if="index == 0" class="col-lg-12 row passport-row">
          <div class="col-lg-6">
            <div class="form-group">
              <small>
                <div class="form-check">
                  <input v-model="payerIsTourist" type="checkbox"
                         v-on:click="payerIsTouristFunc($event)"
                         class="form-check-input" id="payerIsTourist">
                  <label class="form-check-label"
                         for="payerIsTourist">Учасник є
                    покупцем</label>
                </div>
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.form-group {
  .icon.question {
    top: 35px;
  }
  label {
    font-size: 15px;
  }
}
</style>
